module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-5 darker"
  }, [_c('h5', [_vm._v("\n        Custom Sales Channel\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "my-4"
  }, [_vm._v("\n        Define your custom sales channels so you can choose them when adding new reservations. For each channel you can define default invoice settings.\n    ")]), _vm._v(" "), (_vm.getSalesChannels.length < 1) ? _c('div', {
    staticClass: "text-center dark fs-large w-100"
  }, [_vm._v("\n        No sales channels available\n    ")]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "col-sm-6"
  }, [_vm._l((_vm.getSalesChannels), function(salesChannel) {
    return (_vm.getSalesChannels.length > 0) ? _c('div', {
      staticClass: "d-flex align-items-center justify-content-between bg-lighter border-light mb-2 py-1 px-2 activeHover"
    }, [_c('div', {
      staticClass: "darker bold"
    }, [_vm._v(_vm._s(salesChannel.name))]), _vm._v(" "), _c('div', {
      staticClass: "withHover"
    }, [_c('span', {
      staticClass: "lighter bg-dark radius-normal fs-small px-2 pointer",
      on: {
        "click": function($event) {
          return _vm.edit(salesChannel)
        }
      }
    }, [_vm._v("Edit")]), _vm._v(" "), (!salesChannel.isImmutable) ? _c('i', {
      staticClass: "ico ico-delete fs-normal dark pointer ml-2",
      on: {
        "click": function($event) {
          return _vm.clickTrash(salesChannel)
        }
      }
    }) : _vm._e()])]) : _vm._e()
  }), _vm._v(" "), _c('button', {
    staticClass: "btn wide mt-4",
    on: {
      "click": _vm.AddSalesChannel
    }
  }, [_vm._v("Add Sales Channel")])], 2)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-607efeac", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-607efeac"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/TabSalesChannels.vue
// module id = 1590
// module chunks = 0